import { client } from "src/common/axiosClient";

export const signIn = (mbr_id: string, mbr_pw: string) => {
  return client.post("/signin", {
    mbr_id,
    mbr_pw
  });
};

export const signUp = ({
  mbr_id,
  mbr_pw,
  mbr_nm,
  mbr_tel,
  mbr_empl_dt,
  mbr_email
}: {
  mbr_id: string;
  mbr_pw: string;
  mbr_nm: string;
  mbr_tel: string;
  mbr_empl_dt: string;
  mbr_email: string;
}) => {
  return client.post("/signup", {
    cmpn_id: "CP0001",
    mbr_id,
    mbr_pw,
    mbr_nm,
    mbr_tel,
    mbr_empl_dt,
    mbr_email
  });
};

export const getMemberDetail = (mbr_id: string) => {
  return client.post("/api/mbr/detail", {
    mbr_id
  });
};

export const isIdValid = (mbr_id: string) => {
  return client.post("/idDplctChk", {
    mbr_id
  });
};

export const updateMemberInfo = ({
  mbr_id,
  mbr_nm,
  mbr_tel,
  mbr_email,
  mbr_empl_dt
}: {
  mbr_id: string;
  mbr_nm: string;
  mbr_tel: string;
  mbr_email: string;
  mbr_empl_dt: string;
}) => {
  return client.post("/api/mbr/update", {
    mbr_id,
    mbr_nm,
    mbr_tel,
    mbr_email,
    mbr_empl_dt
  });
};

export const updatePassword = ({
  mbr_id,
  mbr_pw,
  mbr_pw_old
}: {
  mbr_id: string;
  mbr_pw: string;
  mbr_pw_old: string;
}) => {
  return client.post("/api/mbr/update/pwd", {
    mbr_id,
    mbr_pw,
    mbr_pw_old
  });
};
